import { ActivityTableConfig } from "../types";

export const getInterestFormTableConfig = (): ActivityTableConfig => {
  return {
    columns: [
      {
        accessorKey: "item",
        header: "Item",
        enableSorting: false,
        size: 100,
        meta: {
          headerClassName: "hide-header-in-column"
        }
      },
      {
        accessorKey: "answer",
        header: "Answer",
        enableSorting: false
      }
    ]
  };
};
